import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import TriggerTemplate from './TriggerTemplate'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'

export default class TriggerComponent extends Rete.Component {
  constructor (config) {
    super(CONST_COMPONENT.TRIGGER)

    this.data.component = TriggerTemplate
    this.socket = config ? config.sockets : null
  }

  builder (node) {
    node.lingualName = lingualName.TRIGGER
    this.setConnection()

    const triggerInput = new Rete.Input(CONST_SOCKET.TRIGGER_INPUT, 'Reply', this.socket.triggerInput, false)
    const triggerOutput = new Rete.Output(CONST_SOCKET.TRIGGER_OUTPUT, '', this.socket.triggerOutput, false)

    return node
      .addInput(triggerInput)
      .addOutput(triggerOutput)
  }

  // eslint-disable-next-line
  worker (node, inputs, outputs) {
    outputs[CONST_SOCKET.TRIGGER_OUTPUT] = node.data
  }

  setConnection() {
    // Trigger may be connected to:
    this.socket.triggerOutput.combineWith(this.socket.referenceInput)
    this.socket.triggerOutput.combineWith(this.socket.newPostbackInputTrigger)    
    this.socket.triggerOutput.combineWith(this.socket.componentListInput)    
  }
}